module.exports = __webpack_public_path__ + "img/appImage-links--3.cff4b48a.svg";